import { render } from "./SnackbarView.vue?vue&type=template&id=1f8be969&scoped=true"
import script from "./SnackbarView.vue?vue&type=script&lang=js"
export * from "./SnackbarView.vue?vue&type=script&lang=js"

import "./SnackbarView.vue?vue&type=style&index=0&id=1f8be969&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8be969"]])

export default __exports__